import { SegNotificacaoModel } from "@/models/message/seg-notificacao.model";

const messages = [] as SegNotificacaoModel[];


export type State = {
  messages: any;
}

export const state: State = {
  messages: messages,
};